import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetch = (get: any) => ({
    type: 'fetch_GET_success',
    payload: get,
});
export const fetchCountry = (country: any) => ({
    type: 'fetch_Country_success',
    payload: country,
});
export const state = (states: any) => ({
    type: 'fetch_State_success',
    payload: states,
});

export const getSpecialityData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2};
            const apiname = Admin_API.regionsss_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const fetchCountryData = () => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {};
            const apiname = SUPRIVISOR_API.getcountry;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchCountry(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const getState = (country:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {countryId:country,q:1};
            const apiname = SUPRIVISOR_API.getstate;
            const response = await LoginService.getData(apiname,payload);
            dispatch(state(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
